const en = {
  // Navbar
  'nav.home': 'Home',
  'nav.catalog': 'Catalog',
  'nav.import': 'Import',
  'nav.featured': 'Featured',
  'nav.contact': 'Contact',
  'nav.cta': 'Import my car',

  // Hero
  'hero.badge': 'Premium Import · all across Europe',
  'hero.title1': 'We import',
  'hero.title2': 'the',
  'hero.title3': 'car',
  'hero.title4': '',
  'hero.title5': 'you\u00a0want',
  'hero.subtitle': 'Exclusive vehicles from Germany, Belgium, the Netherlands and more. With full management and maximum security.',
  'hero.cta.catalog': 'View catalog',
  'hero.cta.quote': 'Request an import',
  'hero.badge.certified': 'Certified',
  'hero.badge.approved': 'Approved',
  'hero.badge.guaranteed': 'Guaranteed',
  'hero.badge.insured': 'Insured',

  // WhyUs
  'whyus.label': 'Our advantages',
  'whyus.title1': 'Why choose',
  'whyus.title2': 'ZS Cars Import?',
  'whyus.subtitle': 'Premium vehicle imports with full transparency and professionalism. Flexible services — ask us with no commitment.',
  'whyus.more': 'Learn more',
  'whyus.b1.title': 'Personalised Import',
  'whyus.b1.desc': 'We find exactly the vehicle you are looking for, with the specifications you want, in any market in Europe.',
  'whyus.b2.title': 'Certified Vehicles',
  'whyus.b2.desc': 'Every vehicle undergoes a thorough technical inspection before purchase. Verified history with no surprises.',
  'whyus.b3.title': 'Complete Process Management',
  'whyus.b3.desc': 'We handle all documentation, coordination and necessary procedures for the import of the vehicle.',
  'whyus.b4.title': 'Safe & Coordinated Transport',
  'whyus.b4.desc': 'We organise vehicle transport from the origin with tracking and planning throughout the entire process.',
  'whyus.b5.title': 'Registration & Procedures',
  'whyus.b5.desc': 'We manage registration in Spain and all documentation. Delivered ready to drive.',
  'whyus.b6.title': 'VIP Service',
  'whyus.b6.desc': 'Dedicated personal advisor throughout the entire process. Available 24/7 to answer any question.',

  // ImportProcess
  'process.label': 'Import process',
  'process.title1': 'Simple, safe and',
  'process.title2': 'transparent',
  'process.subtitle': 'We manage the entire import process from start to finish. You just have to choose your car.',
  'process.cta': 'Start my import',
  'process.s1.title': 'Find your ideal car',
  'process.s1.desc': 'Tell us what vehicle you dream of. Brand, model, year, equipment. Our experts search all over Europe.',
  'process.s1.detail': 'Personalised search across more than 50 international markets',
  'process.s2.title': 'We verify and negotiate',
  'process.s2.desc': 'We inspect the vehicle on-site, verify the full history and negotiate the best price on your behalf.',
  'process.s2.detail': '150-point technical inspection + verified history',
  'process.s3.title': 'We handle all the management',
  'process.s3.desc': 'We coordinate transport, documentation and all necessary procedures until the vehicle arrives in Spain.',
  'process.s3.detail': 'Full operation tracking',
  'process.s4.title': 'Turnkey delivery',
  'process.s4.desc': 'Your vehicle arrives registered and ready to drive. We deliver wherever you want.',
  'process.s4.detail': 'Home delivery anywhere in Spain',

  // FeaturedCars
  'featured.label': 'Featured cars',
  'featured.speed': 'Top speed',
  'featured.power': 'Power',
  'featured.accel': '0-100 km/h',
  'featured.origin': 'Origin',
  'featured.cta': 'Enquire about this vehicle',
  'featured.whatsapp': 'Hello, I am interested in the',
  'featured.whatsapp2': 'Can you give me more information?',

  // Catalog
  'catalog.label': 'Available vehicles',
  'catalog.title1': 'Exclusive',
  'catalog.title2': 'Catalog',
  'catalog.subtitle': 'Selected and verified premium vehicles, ready to import.',
  'catalog.filter.brand': 'Brand',
  'catalog.filter.type': 'Type',
  'catalog.filter.fuel': 'Fuel',
  'catalog.filter.trans': 'Gearbox',
  'catalog.filter.price': 'Price',
  'catalog.filter.all': 'All',
  'catalog.filter.sport': 'Sports',
  'catalog.filter.suv': 'SUV',
  'catalog.filter.sedan': 'Sedan',
  'catalog.filter.gasoline': 'Petrol',
  'catalog.filter.hybrid': 'Hybrid',
  'catalog.filter.electric': 'Electric',
  'catalog.filter.auto': 'Automatic',
  'catalog.filter.manual': 'Manual',
  'catalog.empty': 'No vehicles match these filters',
  'catalog.cta': 'Enquire vehicle',
  'catalog.whatsapp': 'Hello, I am interested in the',
  'catalog.whatsapp2': 'Can you give me more information?',

  // Contact
  'contact.label': 'Contact',
  'contact.title1': 'Import your dream',
  'contact.title2': 'car',
  'contact.subtitle': 'Tell us what vehicle you want and we will prepare a personalised quote with no commitment. We respond in less than 24 hours.',
  'contact.whatsapp': 'WhatsApp',
  'contact.email': 'Email',
  'contact.location': 'Location',
  'contact.location.value': 'Marbella, Málaga',
  'contact.schedule': 'Hours',
  'contact.schedule.value': 'Mon-Fri 9:00-19:00',
  'contact.whatsapp.cta': 'Contact via WhatsApp',
  'contact.form.title': 'Request import',
  'contact.form.name': 'Name',
  'contact.form.name.ph': 'Your name',
  'contact.form.phone': 'Phone',
  'contact.form.phone.ph': '+34 600 000 000',
  'contact.form.email': 'Email',
  'contact.form.email.ph': 'you@email.com',
  'contact.form.model': 'Desired model',
  'contact.form.model.ph': 'E.g.: BMW M4, Mercedes C63 AMG...',
  'contact.form.budget': 'Budget',
  'contact.form.budget.ph': 'Select your budget',
  'contact.form.message': 'Message',
  'contact.form.message.ph': 'Tell us more details about the vehicle you are looking for...',
  'contact.form.submit': 'I want to import my car',
  'contact.form.sending': 'Sending...',
  'contact.form.new': 'New request',
  'contact.success.title': 'Request sent!',
  'contact.success.desc': 'We have received your request. Our team will contact you within 24 hours.',
  'contact.budget.1': 'Less than €30,000',
  'contact.budget.2': '€30,000 - €60,000',
  'contact.budget.3': '€60,000 - €100,000',
  'contact.budget.4': '€100,000 - €150,000',
  'contact.budget.5': 'More than €150,000',

  // Testimonials
  'testimonials.label': 'Testimonials',
  'testimonials.title1': 'What our',
  'testimonials.title2': 'clients say',
  'testimonials.subtitle': 'More than 500 satisfied clients back our track record.',
  'testimonials.badge1': '4.9/5 average rating',
  'testimonials.badge2': 'Verified company',
  'testimonials.badge3': '+500 satisfied clients',
  'testimonials.badge4': '8 years of experience',
  'testimonials.cta.pre': 'Ready to join our satisfied clients?',
  'testimonials.cta': 'Request my import',

  // Footer
  'footer.brand.desc': 'We import premium and sports vehicles from all across Europe with full transparency and security.',
  'footer.nav.title': 'Navigation',
  'footer.services.title': 'Services',
  'footer.contact.title': 'Contact',
  'footer.service1': 'Personalised import',
  'footer.service2': 'Own vehicle transport',
  'footer.service3': '',
  'footer.service4': 'Documentation management',
  'footer.service5': 'VIP service',
  'footer.rights': '© 2026 ZS Cars Import. All rights reserved.',
  'footer.privacy': 'Privacy policy',
  'footer.legal': 'Legal notice',
  'footer.cookies': 'Cookies',

  // Simulator
  'simulator.label': 'Savings calculator',
  'simulator.title1': 'How much do you save',
  'simulator.title2': 'by importing?',
  'simulator.subtitle': 'Calculate the real savings of importing your car from Germany versus buying it in Spain. Indicative prices based on real market data.',
  'simulator.configure': 'Configure your simulation',
  'simulator.car': 'Select the model',
  'simulator.price.de': 'Price in Germany',
  'simulator.price.es': 'Price in Spain',
  'simulator.breakdown': 'Import cost breakdown',
  'simulator.item.price': 'Vehicle price (Germany)',
  'simulator.item.transport': 'Transport costs',
  'simulator.item.transport.sub': 'from',
  'simulator.item.management': 'Management & procedures',
  'simulator.item.taxes': 'Taxes & duties',
  'simulator.item.taxes.sub': 'Variable per vehicle',
  'simulator.item.zscars': 'ZS Cars fixed fee',
  'simulator.total.import': 'Total estimated imported in Spain',
  'simulator.total.spain': 'Approximate price in Spain',
  'simulator.total.import.approx': 'approx.',
  'simulator.cta': 'I want to import this car',
  'simulator.savings.label': 'Your estimated saving',
  'simulator.savings.desc': 'Approximately {{pct}}% less than in Spain',
  'simulator.import.cost': 'Import cost',
  'simulator.spain.cost': 'Price in Spain',
  'simulator.stat.days': 'Days approx.',
  'simulator.stat.certified': 'Certified',
  'simulator.stat.origin': 'Origin',
  'simulator.disclaimer': 'Prices are indicative estimates based on mobile.de data and Spanish dealership listings. Actual costs may vary depending on equipment, year, mileage and exchange rate. Contact our team for an exact personalised quote.',
  'simulator.note': 'Transport costs, taxes and registration may vary depending on the vehicle, CO₂ emissions and current regulations.',

  // CustomOrderCTA
  'customcta.label': 'Custom search',
  'customcta.title': "Can't find the vehicle you're looking for in our catalog?",
  'customcta.subtitle': 'We work on order and personalised search. Contact us and we will find the perfect car for you.',
  'customcta.feat1': 'No commitment',
  'customcta.feat2': 'All of Europe',
  'customcta.feat3': 'Reply within 24h',
  'customcta.feat4': 'VIP service',
  'customcta.btn.whatsapp': 'Message us on WhatsApp',
  'customcta.btn.contact': 'Contact form',
  'customcta.trust': 'More than 500 satisfied clients · 8 years of experience · Marbella, Spain',
  'customcta.whatsapp': 'Hello, I am looking for a vehicle that does not appear in your catalogue. Can you help me with a personalised search?',

  // SEO
  'seo.title': 'ZS Cars Import | Car Import Specialists',
  'seo.description': 'ZS Cars Import — We import exclusive vehicles from Germany, Belgium and the Netherlands. BMW, Mercedes, Porsche, Audi with full customs management and turnkey delivery.',
};

export default en;